<template>
  <DModal :show-close="false" :isBgOverlay="true">
    <div class="d-modal text-dark d-modal__select-teacher-for-sub" slot="insertComponent" style="width: 400px">
      <div class="d-modal__content">
        <h3>{{ i18n[locale]['which_teacher_will'] }} {{ substitute.name }} {{ i18n[locale]['be_substitute_for'] }}?</h3>
        <ul>
          <li class="select-teacher-for-sub__teacher" v-for="teacher in teachers" :key="teacher.id">
            {{ teacher.name }}
            <button type="button" style="padding: 2px 1rem;" class="bttn bttn-primary" @click="$emit('select', teacher)">{{ $t('vue2.common.select') }}</button>
          </li>
        </ul>
      </div>
      <!--
      <div class="d-modal__footer">
        <button @click="$emit('cancel')">{{ $t('vue2.common.remove') }} {{ substitute.name }}</button>
      </div>
    -->
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal'
const I18N = {
  da: {
    which_teacher_will: 'Hvilken person skal',
    be_substitute_for: 'være vikar for'
  },
  en: {
    which_teacher_will: 'Which teacher will',
    be_substitute_for: 'be a substitute for'
  },
  nb: {
    which_teacher_will: 'Hvilken lærer bør',
    be_substitute_for: 'være vikar for'
  }
}
export default {
  components: {DModal},
  props: {
    substitute: {},
    teachers: {
      default: () => []
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N
    }
  }
}
</script>

<style>
.select-teacher-for-sub__teacher {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: #ffffff;
  margin-top: 1rem;
  border: 1px solid #d9d9d9;
  border-radius: 0.25rem;
}

.d-modal__select-teacher-for-sub .d-modal__content {
  padding: 2rem 2rem;
}

.d-modal__select-teacher-for-sub .d-modal__footer {
  margin-top: 2rem;
  background-color: #ffffff;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid #d9d9d9;
}
</style>



// WEBPACK FOOTER //
// DCalendarShowEventSubFor.vue?d7a2d552